module.exports = __webpack_public_path__ + "static/media/video.e237090d.mp4";